import logo from "./logo.svg";
import "./App.scss";
import { BrowserRouter } from "react-router-dom";
import SideBar from "./components/SideBar";
import AppLayout from "./components/AppLayout";
import Header from "./components/Header";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

const configuration = {
  auth: {
    clientId: "dc400292-d1e9-4041-a1c2-1e6980173aa3",
    redirectUri: "/",
    authority:
      "https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

const instance = new PublicClientApplication(configuration);
instance.initialize();

function App() {
  return (
    <MsalProvider instance={instance}>
      <BrowserRouter>
        <div className="wrapper">
          <Header />
          <div className="content">
            <SideBar collapsed={false}></SideBar>
            <AppLayout />
          </div>
        </div>
      </BrowserRouter>
    </MsalProvider>
  );
}

export default App;
